export default "__VITE_PUBLIC_ASSET__255ec999__"